import { Inject, Injectable } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { BehaviorSubject } from 'rxjs';
import { AppConstants } from '../../../app.constants';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  public languageLocale$ = new BehaviorSubject<string>('en');

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private _translationService: L10nTranslationService
  ) {
    var localStorageLanguage = localStorage.getItem(
      AppConstants.L10N_LOCALE_STORAGE_KEY
    );
    if (localStorageLanguage === null) {
      this.languageLocale$.next(_translationService.getLocale().language);
    } else {
      this._translationService
        .setLocale({ language: localStorageLanguage })
        .then(() => {
          this.languageLocale$.next(localStorageLanguage!);
        });
    }
  }
  /**
   * Retrieves the current language set in the translation service.
   *
   * @returns The current language code as a string.
   */
  public getLanguage(): string {
    return this._translationService.getLocale().language;
  }

  /**
   * Sets the language in the translation service and localStorage.
   *
   * @param language The new language code as a string.
   */
  public setLanguage(language: string): void {
    this._translationService.setLocale({ language: language }).then(() => {
      this.languageLocale$.next(language);
      localStorage.setItem(AppConstants.L10N_LOCALE_STORAGE_KEY, language);
    });
  }
}
